import React from 'react';
import {MailCampaignBlock, MailCampaignBlockUnsubscribe} from 'api';

interface Block extends MailCampaignBlock {
  blockable: MailCampaignBlockUnsubscribe;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const {textHtml} = block.blockable;

  const style = {
    color: block.blockable?.textColor,
    backgroundColor: block.blockable?.bodyColor,
    paddingTop: block.blockable?.paddingTop || 0,
    paddingBottom: block.blockable?.paddingBottom || 0,
    paddingLeft: block.blockable?.paddingLeft || 0,
    paddingRight: block.blockable?.paddingRight || 0,
    fontSize: '10px',
  };

  return <div style={style} dangerouslySetInnerHTML={{__html: textHtml}} />;
};
